module.exports = __webpack_public_path__ + "img/notice.eb471e2d.png";